import Button from "@shared/v2/Button";
import { ArrowLeftSolidV6 } from "@shared/v2/Icomoon";
import TextButton from "@shared/v2/TextButton";
import Typography from "@shared/v2/Typography";
import { useNavigate } from "react-router";

const HeaderBar = () => {
  const navigate = useNavigate();
  return (
    <div className="tw-bg-white tw-rounded-[8px] tw-p-[24px] tw-flex tw-justify-between tw-gap-[16px]">
      <TextButton
        size="medium"
        className="tw-pl-0 tw-flex tw-items-center tw-gap-[6px]"
        onClick={() => navigate("/add_ons")}
      >
        <ArrowLeftSolidV6 />
        All Add-Ons
      </TextButton>
      <div className="tw-flex tw-items-center tw-gap-[8px]">
        {/* <span className="tw-text-14d tw-text-gray-50">Got a question?</span>
        <Button size="medium" schema="secondary">
          Talk to an Expert
        </Button> */}
      </div>
    </div>
  );
};

const PurchaseBar = () => (
  <div className="tw-sticky tw-bottom-[24px] tw-max-w-[1112px] tw-w-full tw-mx-auto">
    <div className="tw-mx-[16px] tw-flex tw-justify-between tw-items-center tw-gap-[16px] tw-flex-wrap tw-bg-white tw-rounded-[8px] tw-p-[24px] tw-shadow-dropdown tw-group hover:tw-shadow-[0px_0px_32px_2px_rgba(89,196,196,0.20)] tw-transition-all tw-border-solid tw-border-[1px] tw-border-gray-5 hover:tw-border-[2px] hover:tw-border-theme-primary">
      <div className="tw-flex tw-flex-col tw-gap-[4px]">
        <Typography variant="subtitle-m" className="tw-transition-colors group-hover:!tw-text-theme-primary">
          Revolutionize real estate recruiting with Recruiter.ai
        </Typography>
        <Typography variant="body-s" className="!tw-text-gray-50">
          Only $149 a month. Cancel anytime.
        </Typography>
      </div>
      <Button
        size="medium"
        className="tw-whitespace-nowrap"
        onClick={() =>
          window.open("/launch?slug=brivity-recruiter&redirectPath=/recruiter%3FshowSignUp%3Dtrue", "_blank")
        }
      >
        Sign Up
      </Button>
    </div>
  </div>
);

const RecruiterAi = () => (
  <div className="tw-relative tw-w-full tw-h-full">
    <HeaderBar />
    <iframe
      src="https://www.brivity.com/recruiter-ai-app"
      title="Recruiter AI"
      className="tw-w-full tw-h-full tw-border-none"
    />
    <PurchaseBar />
  </div>
);

export default RecruiterAi;
